import FindControlViewState from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import { SubstrateSearchSuggestionsResponse } from 'owa-search-service';
import { createPeopleFeedback } from 'owa-recipient-common/lib/store/schema/PeopleFeedbackState';
import PersonaType from 'owa-service/lib/contract/PersonaType';
import FindPeopleResponseMessage from 'owa-service/lib/contract/FindPeopleResponseMessage';
import { OwaDate, getUTCString } from 'owa-datetime';
import shouldUse3SPeopleSuggestions from 'owa-substrate-people-suggestions/lib/utils/shouldUse3SPeopleSuggestions';

const CACHE_SOURCE = 'Cache';
const MAILBOX_SOURCE = 'Mailbox';
const DIRECTORY_SOURCE = 'Directory';
const FALLBACK_SOURCE = ' Fallback';

export function resetFeedbackState(recipientWell: FindControlViewState): void {
    recipientWell.peopleFeedbackState = { live: null, cache: null, directory: null };
}

export function populateFeedbackStateNetwork(
    recipientWell: FindControlViewState,
    transactionStartTime: OwaDate,
    response: FindPeopleResponseMessage | SubstrateSearchSuggestionsResponse,
    directory?: boolean
): void {
    if (shouldUse3SPeopleSuggestions && recipientWell.peopleFeedbackState) {
        let feedback = createPeopleFeedback();
        feedback.TimeStamp = getUTCString(transactionStartTime);
        feedback.QueryString = recipientWell.queryString;
        feedback.SuggestionSource = directory ? DIRECTORY_SOURCE : MAILBOX_SOURCE;

        const responseMessage = response as SubstrateSearchSuggestionsResponse;
        feedback.RawResponse = responseMessage ? JSON.stringify(responseMessage) : 'pending';
        if (responseMessage && responseMessage.Instrumentation) {
            feedback.TraceId = responseMessage.Instrumentation.TraceId;
        }

        if (directory) {
            recipientWell.peopleFeedbackState.directory = feedback;
        } else {
            recipientWell.peopleFeedbackState.live = feedback;
        }
    }
}

export function populateFeedbackStateCache(
    recipientWell: FindControlViewState,
    transactionStartTime: OwaDate,
    cacheResults: PersonaType[],
    fallback?: boolean
): void {
    if (shouldUse3SPeopleSuggestions() && recipientWell.peopleFeedbackState) {
        let feedback = createPeopleFeedback();
        feedback.QueryString = recipientWell.queryString;
        feedback.TimeStamp = getUTCString(transactionStartTime);
        feedback.SuggestionSource = fallback ? CACHE_SOURCE + FALLBACK_SOURCE : CACHE_SOURCE;
        feedback.RawResponse = JSON.stringify(cacheResults);

        recipientWell.peopleFeedbackState.cache = feedback;
    }
}
